import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';

@Pipe({
  name: 'groupMessages'
})
export class GroupMessagesPipe implements PipeTransform {
  transform(value: any[], ...args: any[]): any {
    const formatted = {};

    if (value.length > 0) {
      let messageToCheckWith = value[0];

      value.forEach((msg, index) => {
        if (diffInHour(msg.created_at, messageToCheckWith.created_at) > 1) {
          messageToCheckWith = value[index];
        }

        const dateStr = dayjs(messageToCheckWith.created_at).format();
        formatted[dateStr] = formatted[dateStr] ? [...formatted[dateStr], msg] : [msg];
      });
    }

    return formatted;
  }
}

const diffInHour = (date1, date2): number => {
  const d1 = dayjs(date1);
  const d2 = dayjs(date2);

  return d1.diff(d2, 'hour');
};
